import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { parseBuildSearch, BuildSearchParams } from "~/components/build/Show/lib/searchParams";

export type { BuildSearchParams };

/**
 * Hook to extract build-page related query parameters from the URL.
 *
 * Returns schema-validated params via `parseBuildSearch`. The returned object
 * uses URL-level key names (jid, sid, open, tab, annotations_tab).
 *
 * Memoized on the raw search string so consumers get a stable reference
 * and can safely use the result in dependency arrays.
 */
export default function useQueryParams(): BuildSearchParams {
  const [searchParams] = useSearchParams();
  const searchString = searchParams.toString();

  return useMemo(
    () => parseBuildSearch(Object.fromEntries(new URLSearchParams(searchString).entries())),
    [searchString],
  );
}
